<template>
  <noscript id="__gtm_noscript__" v-if="gtmNoscript" v-html="gtmNoscript"></noscript>
  <div :style="{ '--primary-color': style.primaryColor, '--content-alignment': alignment }">
    <NuxtLoadingIndicator />
    <NuxtLayout :name="currentLayoutName">
      <SmartLinkProvider>
        <NuxtPage />
      </SmartLinkProvider>
    </NuxtLayout>
  </div>
  <ScriptTags />
</template>

<script lang="ts" setup>
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import type { SiteStoreWithInit } from './stores/site'
import {contentTypes} from "~/models";
import type { LayoutKey } from '#build/types/nitro-layouts';

const currentLayoutName = ref<false | LayoutKey>('default')

library.add(fas, fab)
useState<boolean>('hasHeroOverlay', () => false)
const siteStore: SiteStoreWithInit = useSiteStore()
if (!siteStore.initialization?.fetchKontentData) {
  throw new Error('Initialization fetchKontentData is not defined in siteStore.')
}

const { locale } = useI18n()

siteStore.initialization.fetchKontentData = siteStore.fetchData(false, locale.value)

try {
  await siteStore.initialization.fetchKontentData
} catch (error) {
  console.error('Error fetching data:', error)
}

siteStore.switchLanguage(locale.value)

const showHeaderAndFooter = useState('showHeaderAndFooter', () => true)
showHeaderAndFooter.value = true

const gtmId = siteStore.siteConfig?.elements?.googleTagManagerId?.value
const gtmNoscript = ref<string | null>(null)

if (gtmId) {
  gtmNoscript.value = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
            height="0" width="0"
            style="display:none;visibility:hidden"></iframe>`
}

const style = useDynamicStyle()

const alignment = computed(() => {
  const map: { [key: string]: string } = {
    left_aligned: 'left',
    centered: 'center',
    justified: 'justify'
  }
  return map[style.contentAlignment]
})
callOnce(() => useCustomCss())

//handle layout changes based on page type
const route = useRoute()
const config = useRuntimeConfig()
let itemId = ''
if (route.query && !config.public.isProduction) {
  if (route.query.itemid) {
    itemId = useSanitize(route.query.itemid as string, 'text')
  }
}
const sanitizedPath = useSanitize(route.path, 'text')
let pageRouteInfo = siteStore.getPage(sanitizedPath, itemId, siteStore.collection)
watch(
  () => pageRouteInfo,
  (routeInfo) => {
    if(routeInfo && routeInfo.type == contentTypes.directory_landing_page.codename){
      currentLayoutName.value = 'directory'
    } else {
      currentLayoutName.value = 'default'
    }
  },
  { immediate: true } // Run immediately on page load
)
</script>
